import './App.scss';
import Home from './Containers/Home/Home'
import Header from './Components/Header/Header'

function App() {
  return (
    <div className="App">
      <Header />
      <Home />
    </div>
  );
}

export default App;
